import type {CategoryPill, EmailComponentTemplate, UserEmailComponentTemplateWithLoadingState} from '@Components/email-maker-block-manager/email-maker-block-manager.types';
import {useAppSelector} from '@/hooks';

export const useSortedCategories = (): CategoryPill[] => {
  const categories = useAppSelector((state) => {
    return state.emailMakerBlockManager.componentCategories;
  });

  const sortedCategories = Array.from(categories).sort((a, b) => {
    return a.sortOrder - b.sortOrder;
  });

  return sortedCategories.map((category) => {
    return {id: category.id, name: category.name, trackingName: category.trackingName};
  });
};

export const useAllComponentTemplates = (): EmailComponentTemplate[] => {
  return useAppSelector((state) => {
    return state.emailMakerBlockManager.componentTemplates;
  });
};

export const useSelectedBlockPanel = (): string | null => {
  return useAppSelector((state) => {
    return state.emailMakerBlockManager.selectedBlockPanel;
  });
};

export const useElementsSubPanel = (): string | null => {
  return useAppSelector((state) => {
    return state.emailMakerBlockManager.elementsSubPanel;
  });
};

export const useUserSavedTemplates = (): UserEmailComponentTemplateWithLoadingState[] => {
  return useAppSelector((state) => {
    return state.emailMakerBlockManager.userComponentTemplates;
  });
};

export const useHasUserRecentlySavedTemplate = (): boolean => {
  return useAppSelector((state) => {
    return !!state.emailMakerBlockManager.recentlySavedUserTemplate;
  });
};
